module.exports = __webpack_public_path__ + "static/media/operador-logo-amil-dental.f44d9052.svg";